import { Injectable } from '@angular/core';
import {
    Route,
    Router,
    CanLoad,
    CanActivate,
    ActivatedRouteSnapshot,
    RouterStateSnapshot
} from '@angular/router';
import { SharedService } from '../services/shared.service';
import { UserService } from '../services/user.service';

@Injectable()
export class AuthGuardService implements CanLoad, CanActivate {
    constructor(private router: Router, private userService: UserService) {
    }

    canLoad(route: Route): boolean {
        // let url: string = route.path;
        // if (this.authService.isUserLoggedIn()) {
        //     return true;
        // }
        // this.authService.setRedirectUrl(url);
        // this.router.navigate([this.authService.getLoginUrl()]);
        // return false;

        if (this.userService.isUserLoggedIn()) {
            let user = this.userService.getUser();
            SharedService.get(SharedService.AfterLogIn).emit({
                isUserLoggedIn: true,
                username: user.username,
                screenCode: user.screenCode
            });

            return true;
        }
        else {
            this.router.navigate(['login']);
        }
        return false;
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        // let url: string = state.url;
        //     console.log('Url:'+ url);
        //     if (this.authService.isUserLoggedIn()) {
        //       return true; 
        //     }
        // this.authService.setRedirectUrl(url);
        // this.router.navigate([ this.authService.getLoginUrl() ]);
        // return false;

        if (this.userService.isUserLoggedIn()) {
            let user = this.userService.getUser();
            SharedService.get(SharedService.AfterLogIn).emit({
                isUserLoggedIn: true,
                username: user.username,
                screenCode: user.screenCode
            });

            return true;
        }
        else {
            this.router.navigate(['login']);
        }
        return false;
    }
}

@Injectable()
export class CanActivateLogoutViaAuthGuard implements CanActivate {
    constructor() { }

    canActivate() {
        SharedService.get(SharedService.AfterLogIn).emit({
            isUserLoggedIn: false,
            username: '',
            screenCode: ''
        });

        return true;
    }
}